import { use, useEffect, useState } from "react";
import styles from "./AccountTickets.module.css";
import Button from "./Button";
import { Link } from "react-router-dom";
import { getFile, getUserTickets } from "services/api";
import Spinner from "./Spinner";

const AccountTickets = () => {

  const [tickets, setTickets] = useState([]);
  const [appearedTickets, setAppearedTickets] = useState([]);
  const [sortType, setSortType] = useState("desc");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleGetTickets = async () => {
    setLoading(true);
    const response = await getUserTickets();
    if (response.success) {
      console.log("Billets récupérés avec succès", response.data);
      setTickets(response.data);
      const sortedTickets = [...response.data].sort((a, b) => new Date(b.date) - new Date(a.date));
      setAppearedTickets(sortedTickets);
    } else {
      setError("Erreur lors de la récupération des billets");
      console.error("Erreur lors de la récupération des billets", response.error);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (!tickets.length && !error) {
      handleGetTickets();
    }
  }, []);

  return (
    <div className={styles.AccountTickets}>
      <div className={styles.Title}>Liste de vos billets</div>

      <div className={styles.Filter}>
        <div>
          <label>Réservation</label>
          <select onChange={(e) => {
            const value = e.target.value;
            if (value === "all") {
              const sortedTickets = [...tickets].sort((a, b) => {
                if (sortType === "asc") {
                  return new Date(a.date) - new Date(b.date);
                } else {
                  return new Date(b.date) - new Date(a.date);
                }
              });
              setAppearedTickets(sortedTickets);
            } else {
              console.log("Filtrer les billets par ID :", value);

              const filteredTickets = tickets.filter(ticket => String(ticket.spectacle_date_id) === value);
              setAppearedTickets(filteredTickets);
            }
          }}>
            <option value="all">Tous le réservation</option>
            {tickets.map((ticket, index) => (
              <option key={index} value={ticket.spectacle_date_id}>{ticket.spectacle_title}({ticket.date_formatted})</option>
            ))}
          </select>
        </div>
        <div>
          <label>Date</label>
          <select
            onChange={(e) => {
              const value = e.target.value;
              console.log("Trier les billets par date :", value);
              setSortType(value);
              const sortedTickets = [...appearedTickets].sort((a, b) => {
                if (value === "asc") {
                  return new Date(a.date) - new Date(b.date);
                } else {
                  return new Date(b.date) - new Date(a.date);
                }
              });
              setAppearedTickets(sortedTickets);
            }
            }
          >
            <option value="desc">Décroissante</option>
            <option value="asc">Croissante</option>
          </select>
        </div>
      </div>

      {loading && (
        <Spinner />
      )}

      <ul className={styles.TicketsList}>
        {appearedTickets.map((ticket, index) => (

          <li key={index}>
            <div className={`${styles.TicketItem} ${ticket.statut === "Annulée" ? styles.Cancelled : ticket.statut === "Validé" ? styles.Active : ""}`}>
              <div className={`${styles.TicketDetails} ${styles.WithImage}`}>
                <div className={styles.TicketImage}>
                  <img src={ticket.image.path} alt={ticket.image.name} />
                </div>
                <div>
                  <div className={styles.TicketNumber}>{ticket.spectacle_title}</div >
                  <p>{ticket.date_formatted}</p>
                  <p className={styles.TicketLocation}>{ticket.lieu}</p>
                </div>
              </div>
              <div className={styles.TicketActions}>
                <div className={styles.Status}>
                  <span>{ticket.status}</span>
                </div>
                <div className={styles.Invoice}>
                  {ticket.invoiceURL && ticket.invoiceURL !== '#' && <Link onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    getFile(ticket.invoiceURL).then((response) => {
                      if (response && response instanceof Blob) {
                        const url = window.URL.createObjectURL(response);
                        window.open(url, "_blank");
                        setTimeout(() => window.URL.revokeObjectURL(url), 10000);
                      }
                    })
                  }} to={ticket.invoiceURL} target="_blank">
                    Télécharger tous les billets ({ticket.tickets ? ticket.tickets.length : 0})
                  </Link>}
                </div>
              </div>
            </div>
            {ticket.tickets && ticket.tickets.length > 0 &&
              <ul className={styles.SubTicketsList}>
                {ticket.tickets.map((subTicket) => (
                  <li key={subTicket.ticket_id}>
                    <div className={`${styles.TicketItem} ${subTicket.status === "Annulée" ? styles.Cancelled : ""}`}>
                      <div className={styles.TicketDetails}>
                        <div className={styles.TicketNumber}>Billet n°{subTicket.numero}</div >
                        <p className={styles.TicketLocation}>Commande n°{subTicket.commande_id}</p>
                        <p>Commande réalisée le : {subTicket.date_commande_formatted}</p>
                      </div>
                      <div className={styles.TicketActions}>
                        <div className={styles.Invoice}>
                          {subTicket.download_url && subTicket.download_url !== '#' && <Link onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            console.log("Téléchargement du billet", subTicket.download_url);

                            getFile(subTicket.download_url).then((response) => {
                              if (response && response instanceof Blob) {
                                const url = window.URL.createObjectURL(response);
                                window.open(url, "_blank");
                                setTimeout(() => window.URL.revokeObjectURL(url), 10000);
                              }
                            })
                          }} to={subTicket.download_url} target="_blank">
                            Télécharger le billet
                          </Link>}
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>}
          </li>
        ))}
        {tickets.length === 0 && !loading && !error && (
          <li className={styles.Title}>Aucun billet trouvé.</li>
        )}
      </ul>
    </div >
  );
}

export default AccountTickets;
